module.exports = __webpack_public_path__ + "static/media/map.dfb392b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/map.svg
// module id = 839
// module chunks = 0